module.exports = __webpack_public_path__ + "static/media/SDFSA_4-845w.efb1ea36.webp";